import {MegaphoneIcon, MicromorgiIcon} from '@/assets/icons/icons'
import {DonationType} from '@/features/recurring-gift/types'
import {FC, ReactElement} from 'react'
import {useTranslation} from 'react-i18next'
import {
    StyledCurrentPlanAmount,
    StyledCurrentPlanCount,
    StyledCurrentPlanDescription,
    StyledInfoIcon,
    StyledInformCurrentPlan,
    StyledInformCurrentPlanColumn
} from './style'

type CurrentMembershipPlanProps = {
    currentPlan: DonationType
    countOfExclusiveGroups: number
    extraContent?: ReactElement[][]
    renderMegaphoneText?: () => React.ReactNode
    onClickTooltip?: (plan: DonationType) => void
}
const CurrentMembershipPlan: FC<CurrentMembershipPlanProps> = ({
    currentPlan,
    countOfExclusiveGroups,
    extraContent,
    renderMegaphoneText,
    onClickTooltip
}) => {
    const {t} = useTranslation()
    return (
        <StyledInformCurrentPlan extraContent={t('rookie_my_profile:membership:current_plan')}>
            {onClickTooltip && <StyledInfoIcon onClick={() => onClickTooltip(currentPlan)} />}
            <StyledInformCurrentPlanColumn>
                <StyledCurrentPlanAmount>
                    <MicromorgiIcon />
                    {currentPlan.amount}
                </StyledCurrentPlanAmount>
                {extraContent?.[0]?.map(element => element)}
            </StyledInformCurrentPlanColumn>
            <StyledInformCurrentPlanColumn>
                <StyledCurrentPlanDescription>
                    <div>
                        <MegaphoneIcon />

                        {renderMegaphoneText?.() || (
                            <>
                                <StyledCurrentPlanCount>{countOfExclusiveGroups}</StyledCurrentPlanCount>
                                {t('rookie_my_profile:membership:exclusive_group')}
                            </>
                        )}
                    </div>
                </StyledCurrentPlanDescription>
                {extraContent?.[1]?.map(element => element)}
            </StyledInformCurrentPlanColumn>
        </StyledInformCurrentPlan>
    )
}
export default CurrentMembershipPlan
